import { CSSProperties } from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';

interface SelectOption {
    id: number | string;
    label: string;
}

interface SelectComponentProps {
    label: string;
    value: number | string;
    onChange: (value: string | number) => void;
    options: SelectOption[];
    styles?: CSSProperties;
}

export default function SelectComponent({ label, value, onChange, options, styles }: SelectComponentProps) {
    const handleChange = (event: SelectChangeEvent<number | string>) => {
        const newValue = event.target.value;
        
        if (newValue !== undefined && newValue !== '') {
            onChange(newValue);
        }
    };


    return (
        <FormControl fullWidth sx={styles}>
            <InputLabel id={`${label}-label`}>{label}</InputLabel>
            <Select
                labelId={`${label}-label`}
                className='custom-select'
                value={value || ''}
                label={label}
                onChange={handleChange}
            >
                {options.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}